import { Component, OnInit, HostListener } from '@angular/core';
import * as jQ from 'jquery';

@Component({
  selector: 'app-boxing',
  templateUrl: './boxing.component.html',
  styleUrls: ['./boxing.component.css']
})
export class BoxingComponent implements OnInit {

	@HostListener('document:scroll', ['$event']) onScroll(e) {
		let scrollPosition = window.scrollY;
    let height = window.innerHeight;
    let opacity = ((height-scrollPosition)/height);
    jQ('.bg-img').css('opacity', opacity);
	}
  constructor() { }

  ngOnInit() {
  }

}
